

export const constants = {
    menuIconSize: 28,
    cellInputMaxWidth: 100,
    cellInputMaxWidthWeekOverview: 130,
};